import { DatePicker } from 'imaginarity-react-ui';
import * as React from 'react';
import { useImgI18N } from 'services/ImgI18N';
import { BaseEditItem } from '../GeneralPostEdit';
import { useGPEState } from '../Helpers/UseGPEState';
import { EditorsSC as T } from './EditorsSC';

interface EditTwoDatesProps<T> {
    firstGetter: (value: T) => Date | undefined;
    secondGetter: (value: T) => Date | undefined;
    showTime?: boolean;
}


const EditTwoDates = <T extends BaseEditItem = BaseEditItem>(p: EditTwoDatesProps<T>) => {
    const { t } = useImgI18N("admin");
    const { firstGetter, secondGetter, showTime } = p;
    const { value: val1, setValue: setVal1 } = useGPEState(firstGetter);
    const { value: val2, setValue: setVal2 } = useGPEState(secondGetter);

    const date1 = React.useMemo(() => {
        let date = new Date();
        if (val1) {
            date = new Date(val1);
        }

        return new Date(
            date.getUTCFullYear(),
            date.getUTCMonth(),
            date.getUTCDate(),
            date.getUTCHours(),
            date.getUTCMinutes(),
            date.getUTCSeconds(),
        );
    }, [val1]);
    const date2 = React.useMemo(() => {
        let date = new Date();
        if (val2) {
            date = new Date(val2);
        }

        return new Date(
            date.getUTCFullYear(),
            date.getUTCMonth(),
            date.getUTCDate(),
            date.getUTCHours(),
            date.getUTCMinutes(),
            date.getUTCSeconds(),
        );
    }, [val2]);

    const setDate1 = (d: Date) => {
        setVal1(d.toISOString() as any);
    }
    const setDate2 = (d: Date) => {
        setVal2(d.toISOString() as any);
    }

    return (
        <div>
            <T.ETDGrid>
                <DatePicker
                    value={date1}
                    dateFormat="yyyy-MM-dd"
                    onChange={setDate1}
                    timeIntervals={showTime ? 15 : undefined}
                    showTodayText={t("today")}
                    noMargin
                    showYearDropdown
                    showMonthDropdown
                />
                <DatePicker
                    value={date2}
                    dateFormat="yyyy-MM-dd"
                    onChange={setDate2}
                    timeIntervals={showTime ? 15 : undefined}
                    showTodayText={t("today")}
                    noMargin
                    showYearDropdown
                    showMonthDropdown
                />
            </T.ETDGrid>
        </div>

    );
}
export default EditTwoDates;
